import { Shimmer, ShimmerProps } from 'component-library';
import { cn } from 'component-library/utils';

export const PendingPill = ({ className, ...delegated }: ShimmerProps) => (
  <Shimmer className={cn('h-8 w-[100px] rounded-l-full rounded-r-full', className)} {...delegated} />
);
